import { createContext } from 'react';

// Notifications now live in the shared package so the DMC and the TO run the
// same provider; re-exported here to keep the existing `contexts` imports valid.
export { NotificationsContext } from '@koob/notifications';

export const AppContext = createContext({});
export const AuthContext = createContext({});
export const BookingContext = createContext({});
export const CacheContext = createContext({});
export const LanguageContext = createContext({});
